// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  min-height: 100vh;
  padding: 20px;
}

.container {
  max-width: 840px;
  margin: 0 auto;
}

.header {
  text-align: center;
  margin-bottom: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
}

.header-controls {
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
}

.title {
  font-size: 2.5rem;
  font-weight: bold;
  color: white;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
  margin: 0;
  display: flex;
  align-items: center;
  gap: 15px;
}

.dino-icon {
  width: 48px;
  height: 48px;
  filter: drop-shadow(2px 2px 4px rgba(0, 0, 0, 0.3));
  animation: bounce-subtle 3s ease-in-out infinite;
}

@keyframes bounce-subtle {
  0%, 50%, 100% {
    transform: translateY(0px);
  }
  25% {
    transform: translateY(-3px);
  }
  75% {
    transform: translateY(-1px);
  }
}

.refresh-btn {
  background: rgba(255, 255, 255, 0.2);
  border: 2px solid rgba(255, 255, 255, 0.3);
  color: white;
  padding: 12px 24px;
  border-radius: 25px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 600;
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
  white-space: nowrap;
}

.refresh-btn:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.3);
  border-color: rgba(255, 255, 255, 0.5);
  transform: translateY(-2px);
}

.refresh-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.last-updated {
  background: rgba(255, 255, 255, 0.15);
  color: white;
  padding: 12px 20px;
  border-radius: 20px;
  font-size: 0.9rem;
  font-weight: 500;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  text-align: center;
  min-width: 200px;
}

.auto-update-info {
  font-size: 0.75rem;
  margin-top: 4px;
  opacity: 0.8;
  font-weight: 400;
  transition: all 0.3s ease;
}

.last-updated.updating {
  background: rgba(127, 176, 105, 0.2);
  border-color: rgba(127, 176, 105, 0.4);
}

.last-updated.updating .auto-update-info {
  opacity: 1;
  color: #7fb069;
  font-weight: 500;
}

.error-message {
  background: rgba(255, 107, 107, 0.9);
  color: white;
  padding: 20px;
  border-radius: 12px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 15px;
  backdrop-filter: blur(10px);
}

.retry-btn {
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: white;
  padding: 8px 16px;
  border-radius: 20px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: all 0.3s ease;
}

.retry-btn:hover {
  background: rgba(255, 255, 255, 0.3);
}

.loading {
  text-align: center;
  padding: 60px 20px;
  color: white;
}

.spinner {
  width: 50px;
  height: 50px;
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-top: 4px solid white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 20px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@media (max-width: 768px) {
  .header {
    flex-direction: column;
    text-align: center;
  }
  
  .header-controls {
    flex-direction: column;
    gap: 15px;
  }
  
  .title {
    font-size: 2rem;
    gap: 10px;
    flex-direction: column;
    text-align: center;
  }
  
  .dino-icon {
    width: 40px;
    height: 40px;
  }
  
  .last-updated {
    min-width: auto;
    width: 100%;
  }
  
  .error-message {
    flex-direction: column;
    text-align: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,2CAA2C;EAC3C,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mDAAmD;EACnD,gDAAgD;AAClD;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;EAC3B,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,UAAU;EACV,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,2BAA2B;EAC3B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,SAAS;IACT,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;AACF","sourcesContent":[".App {\n  min-height: 100vh;\n  padding: 20px;\n}\n\n.container {\n  max-width: 840px;\n  margin: 0 auto;\n}\n\n.header {\n  text-align: center;\n  margin-bottom: 30px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 20px;\n}\n\n.header-controls {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  flex-wrap: wrap;\n}\n\n.title {\n  font-size: 2.5rem;\n  font-weight: bold;\n  color: white;\n  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);\n  margin: 0;\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n\n.dino-icon {\n  width: 48px;\n  height: 48px;\n  filter: drop-shadow(2px 2px 4px rgba(0, 0, 0, 0.3));\n  animation: bounce-subtle 3s ease-in-out infinite;\n}\n\n@keyframes bounce-subtle {\n  0%, 50%, 100% {\n    transform: translateY(0px);\n  }\n  25% {\n    transform: translateY(-3px);\n  }\n  75% {\n    transform: translateY(-1px);\n  }\n}\n\n.refresh-btn {\n  background: rgba(255, 255, 255, 0.2);\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  color: white;\n  padding: 12px 24px;\n  border-radius: 25px;\n  cursor: pointer;\n  font-size: 1rem;\n  font-weight: 600;\n  backdrop-filter: blur(10px);\n  transition: all 0.3s ease;\n  white-space: nowrap;\n}\n\n.refresh-btn:hover:not(:disabled) {\n  background: rgba(255, 255, 255, 0.3);\n  border-color: rgba(255, 255, 255, 0.5);\n  transform: translateY(-2px);\n}\n\n.refresh-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.last-updated {\n  background: rgba(255, 255, 255, 0.15);\n  color: white;\n  padding: 12px 20px;\n  border-radius: 20px;\n  font-size: 0.9rem;\n  font-weight: 500;\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  text-align: center;\n  min-width: 200px;\n}\n\n.auto-update-info {\n  font-size: 0.75rem;\n  margin-top: 4px;\n  opacity: 0.8;\n  font-weight: 400;\n  transition: all 0.3s ease;\n}\n\n.last-updated.updating {\n  background: rgba(127, 176, 105, 0.2);\n  border-color: rgba(127, 176, 105, 0.4);\n}\n\n.last-updated.updating .auto-update-info {\n  opacity: 1;\n  color: #7fb069;\n  font-weight: 500;\n}\n\n.error-message {\n  background: rgba(255, 107, 107, 0.9);\n  color: white;\n  padding: 20px;\n  border-radius: 12px;\n  margin-bottom: 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 15px;\n  backdrop-filter: blur(10px);\n}\n\n.retry-btn {\n  background: rgba(255, 255, 255, 0.2);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  color: white;\n  padding: 8px 16px;\n  border-radius: 20px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  transition: all 0.3s ease;\n}\n\n.retry-btn:hover {\n  background: rgba(255, 255, 255, 0.3);\n}\n\n.loading {\n  text-align: center;\n  padding: 60px 20px;\n  color: white;\n}\n\n.spinner {\n  width: 50px;\n  height: 50px;\n  border: 4px solid rgba(255, 255, 255, 0.3);\n  border-top: 4px solid white;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin: 0 auto 20px;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n@media (max-width: 768px) {\n  .header {\n    flex-direction: column;\n    text-align: center;\n  }\n  \n  .header-controls {\n    flex-direction: column;\n    gap: 15px;\n  }\n  \n  .title {\n    font-size: 2rem;\n    gap: 10px;\n    flex-direction: column;\n    text-align: center;\n  }\n  \n  .dino-icon {\n    width: 40px;\n    height: 40px;\n  }\n  \n  .last-updated {\n    min-width: auto;\n    width: 100%;\n  }\n  \n  .error-message {\n    flex-direction: column;\n    text-align: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
